import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const VendorAuthContext = createContext(null);

export const useVendorAuth = () => {
  const context = useContext(VendorAuthContext);
  if (!context) {
    throw new Error('useVendorAuth must be used within a VendorAuthProvider');
  }
  return context;
};

export const VendorAuthProvider = ({ children }) => {
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkVendorAuth();
  }, []);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (res) => res,
      (error) => {
        if (error.response?.status === 401 && vendor && error.config?.url?.includes('/api/vendor/')) {
          setVendor(false);
          window.location.href = '/vendor/login';
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(interceptor);
  }, [vendor]);

  const checkVendorAuth = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/vendor/auth/me`, {
        withCredentials: true
      });
      setVendor(response.data);
    } catch {
      setVendor(false);
    } finally {
      setLoading(false);
    }
  };

  const sendOtp = async (email) => {
    const response = await axios.post(
      `${API_URL}/api/vendor/auth/send-otp`,
      { email },
      { withCredentials: true }
    );
    return response.data;
  };

  const verifyOtp = async (email, otp) => {
    const response = await axios.post(
      `${API_URL}/api/vendor/auth/verify-otp`,
      { email, otp },
      { withCredentials: true }
    );
    setVendor(response.data);
    return response.data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API_URL}/api/vendor/auth/logout`, {}, { withCredentials: true });
    } catch (error) {
      console.error('Vendor logout error:', error);
    }
    setVendor(false);
  };

  const updateVendor = (updated) => {
    setVendor(updated);
  };

  const value = {
    vendor,
    loading,
    sendOtp,
    verifyOtp,
    logout,
    updateVendor,
    isAuthenticated: !!vendor,
  };

  return (
    <VendorAuthContext.Provider value={value}>
      {children}
    </VendorAuthContext.Provider>
  );
};
